import { createBrowserHistory } from 'history' // https://github.com/remix-run/history/blob/3e9dab413f4eda8d6bce565388c5ddb7aeff9f7e/docs/getting-started.md

export default createBrowserHistory()
